"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Theme = _interopRequireDefault(require("../Theme"));

var _theme = _interopRequireDefault(require("../Theme/lib/AirasiaMove/theme"));

var _star_inverted_icon = _interopRequireDefault(require("../Icon/statics/star_inverted_icon"));

var _blocked_icon = _interopRequireDefault(require("../Icon/statics/blocked_icon"));

var _cross_icon = _interopRequireDefault(require("../Icon/statics/cross_icon"));

var _volume_off_icon = _interopRequireDefault(require("../Icon/statics/volume_off_icon"));

var _bassinet_icon = _interopRequireDefault(require("../Icon/statics/bassinet_icon"));

var _constant = require("./constant");

var _seatTile = _interopRequireDefault(require("./seatTile.proptypes"));

var _excluded = ["theme", "accessible", "type", "status", "topIcon", "centerIcon", "centerText", "tileSize", "topIconSpacing", "onClick"];

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var SeatTileContainer = _styledComponents.default.div.withConfig({
  displayName: "SeatTile__SeatTileContainer",
  componentId: "sc-fc7f8b-0"
})(["display:inline-flex;flex-direction:column;"]);

var SeatTileWrapper = _styledComponents.default.div.withConfig({
  displayName: "SeatTile__SeatTileWrapper",
  componentId: "sc-fc7f8b-1"
})(["", " ", ""], function (_ref) {
  var onClick = _ref.onClick;
  return onClick && "cursor: pointer;";
}, function (_ref2) {
  var disabled = _ref2.disabled;
  return disabled && "cursor: not-allowed;";
});

var Tile = _styledComponents.default.div.withConfig({
  displayName: "SeatTile__Tile",
  componentId: "sc-fc7f8b-2"
})(["width:", ";height:", ";border-radius:calc(", " / 2 * 0.8);background:", ";display:flex;justify-content:center;align-items:center;box-sizing:border-box;", ";"], function (_ref3) {
  var tileLength = _ref3.tileLength;
  return tileLength;
}, function (_ref4) {
  var tileLength = _ref4.tileLength;
  return tileLength;
}, function (_ref5) {
  var tileLength = _ref5.tileLength;
  return tileLength;
}, function (_ref6) {
  var backgroundColor = _ref6.backgroundColor;
  return backgroundColor;
}, function (_ref7) {
  var borderColor = _ref7.borderColor;
  return borderColor && (0, _styledComponents.css)(["border:1px solid ", ";"], borderColor);
});

var TopIconWrapper = _styledComponents.default.div.withConfig({
  displayName: "SeatTile__TopIconWrapper",
  componentId: "sc-fc7f8b-3"
})(["width:", ";height:", ";display:flex;justify-content:center;align-items:flex-end;"], function (_ref8) {
  var tileLength = _ref8.tileLength;
  return tileLength;
}, function (_ref9) {
  var topIconHeight = _ref9.topIconHeight;
  return topIconHeight;
});

var CenterText = _styledComponents.default.span.withConfig({
  displayName: "SeatTile__CenterText",
  componentId: "sc-fc7f8b-4"
})(["font-size:", ";font-family:", ";color:", ";text-transform:uppercase;"], function (_ref10) {
  var theme = _ref10.theme;
  return theme.fontSize.XSmall;
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.fontFamily.default;
}, function (_ref12) {
  var color = _ref12.color;
  return color;
});

var SeatTile = function SeatTile(props) {
  var theme = props.theme,
      accessible = props.accessible,
      type = props.type,
      status = props.status,
      topIcon = props.topIcon,
      centerIcon = props.centerIcon,
      centerText = props.centerText,
      tileSize = props.tileSize,
      topIconSpacing = props.topIconSpacing,
      onClick = props.onClick,
      rest = (0, _objectWithoutProperties2.default)(props, _excluded);
  var lineHeight = _theme.default.lineHeight,
      colors = _theme.default.colors;
  var isSelected = status === _constant.SEAT_STATUS.SELECTED;
  var isUnavailable = status === _constant.SEAT_STATUS.UNAVAILABLE;
  var isBlocked = status === _constant.SEAT_STATUS.BLOCKED;
  var tileText = centerText === null || centerText === void 0 ? void 0 : centerText.substring(0, 3);
  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);
  var seatStyle = _constant.SEAT_STYLE[type] || _constant.SEAT_STYLE[_constant.DEFAULT_SEAT_TYPE];
  var seatLabel = _constant.SEAT_LABEL[type] || _constant.SEAT_LABEL[_constant.DEFAULT_SEAT_TYPE];
  var tileLength = lineHeight[tileSize];
  var topIconHeight = lineHeight[topIconSpacing];

  var getTopIcon = function getTopIcon() {
    // always show if there's bassinet from the seat
    if (topIcon === _constant.SEAT_TOP_ICON.BASSINET_ICON) {
      return /*#__PURE__*/_react.default.createElement(TopIconWrapper, {
        tileLength: tileLength,
        topIconHeight: topIconHeight
      }, /*#__PURE__*/_react.default.createElement(_bassinet_icon.default, {
        fontsize: "medium",
        themeColor: "greyDark",
        "aria-label": "Bassinet icon"
      }));
    }

    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
  };

  var getCenterIcon = function getCenterIcon() {
    if (centerIcon === _constant.SEAT_CENTER_ICON.VOLUME_OFF_ICON) {
      return /*#__PURE__*/_react.default.createElement(_volume_off_icon.default, {
        fontsize: "XSmall",
        themeColor: "default",
        "aria-label": "Quiet zone"
      });
    }

    if (centerIcon === _constant.SEAT_CENTER_ICON.STAR_ICON) {
      return /*#__PURE__*/_react.default.createElement(_star_inverted_icon.default, {
        fontsize: "XSmall",
        themeColor: "green",
        "aria-label": "Star icon"
      });
    }

    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null);
  };

  var getNormalTile = function getNormalTile() {
    return /*#__PURE__*/_react.default.createElement(Tile, {
      backgroundColor: seatStyle.backgroundColor,
      tileLength: tileLength,
      "aria-label": "Seat available"
    }, getCenterIcon());
  };

  var getUnavailableTile = function getUnavailableTile() {
    return /*#__PURE__*/_react.default.createElement(Tile, {
      backgroundColor: colors.greyLight,
      tileLength: tileLength,
      "aria-label": "Seat unavailable"
    }, /*#__PURE__*/_react.default.createElement(_cross_icon.default, {
      fontsize: "titleNormal",
      themeColor: "default",
      "aria-label": "Unavailable icon"
    }));
  };

  var getBlockedTile = function getBlockedTile() {
    return /*#__PURE__*/_react.default.createElement(Tile, {
      backgroundColor: colors.greyLight,
      tileLength: tileLength,
      "aria-label": "Seat blocked"
    }, /*#__PURE__*/_react.default.createElement(_blocked_icon.default, {
      fontsize: "titleNormal",
      themeColor: "default",
      "aria-label": "Blocked icon"
    }));
  };

  var getSelectedTile = function getSelectedTile() {
    return /*#__PURE__*/_react.default.createElement(Tile, {
      backgroundColor: colors.default,
      borderColor: colors.secondary,
      tileLength: tileLength,
      "aria-label": "Seat selected"
    }, /*#__PURE__*/_react.default.createElement(CenterText, {
      color: colors.secondary,
      "aria-label": "Passenger name"
    }, tileText));
  };

  var getTile = function getTile() {
    if (isSelected) return getSelectedTile();
    if (isUnavailable) return getUnavailableTile();
    if (isBlocked) return getBlockedTile();
    return getNormalTile();
  };

  var getMain = function getMain() {
    return /*#__PURE__*/_react.default.createElement(SeatTileContainer, null, getTopIcon(), /*#__PURE__*/_react.default.createElement(SeatTileWrapper, (0, _extends2.default)({
      role: "button",
      tabIndex: accessible ? 0 : -1,
      onClick: onClick,
      onKeyPress: function onKeyPress(e) {
        if (e.key === 'Enter') onClick();
      },
      disabled: isUnavailable || isBlocked,
      "aria-label": seatLabel
    }, rest), getTile()));
  };

  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};

SeatTile.propTypes = _seatTile.default.PropTypes;
SeatTile.defaultProps = _seatTile.default.DefaultProps;
var _default = SeatTile;
exports.default = _default;